import React, { Component } from "react";
import { connect } from "react-redux";
import * as XLSX from "xlsx";
import {
  Select,
  Card,
  Checkbox,
  Popover,
  Tabs,
  Radio,
  Input,
  Tooltip,
  Table,
  Button,
  message,
  Divider,
  Switch,
  Tag,
} from "antd";
import {
  req_list_lrs_buildingSpace,
  req_list_lrs_spaceInformation,
  req_list_lrs_spaceSessionTime,
  req_add_lrs_lend,
  req_send_mail,
} from "../../api";
import { InfoCircleOutlined } from "@ant-design/icons";
import { getEvoucher } from "../../utils/dataUtil";
import { API_BASE } from "../../utils/contrains";
import { formateDate } from "../../utils/dateUtil";
const { TabPane } = Tabs;
const { Option } = Select;

class UserBorrowSpace extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    loading: false,
    peopleModalChoice: [
      { label: "個人使用", value: "SINGLE" },
      { label: "多人使用", value: "GROUP" },
    ],
    peopleModal: "SINGLE",
    buildings: [],
    rooms: [],
    sessiontimes: [],
    sessionDates: [],
    selectedSessiontimes: [],
    isSelected: "NONE",
    isCanNotSubmit: true,
    selectedRoom: "NONE",
    selectedRoomInfo: null,
    tabActive: "0",
    onlyLendOneSession: "NO",
    groupPeople: [],
    showSessionTimeStyle: "TIME",
    item: {
      ApplyStatus: "APPLY",
      ApplyNumber: getEvoucher(),
      OperatorId: this.props.user.userCode,
      OperatorName: this.props.user.userName,
      OperatorEmail:
        this.props.user.userCode.length > 7
          ? this.props.user.userCode + "@gm.tut.edu.tw"
          : this.props.user.userCode + "@mail.tut.edu.tw",
      BorrowerId: this.props.user.userCode,
      BorrowerName: this.props.user.userName,
      BorrowerEmail: "",
      BorrowerPhone: "",
      BorrowDescription: "",
      MustConfirmLevel: "",
      ConfirmorACode: "",
      ConfirmorAName: "",
      ConfirmorAEmail: "",
      ConfirmorBCode: "",
      ConfirmorBName: "",
      ConfirmorBEmail: "",
      ConfirmorCCode: "",
      ConfirmorCName: "",
      ConfirmorCEmail: "",
      BuildingCode: "",
      BuildingName: "",
      RoomCode: "",
      RoomName: "",
      SiteCode: "NONE",
      DateTag: "",
      WeekCode: "",
      TimeStart: "",
      TimeEnd: "",
      TimeName: "",
    },
    items: [],
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
    this.api_list_buildings();
  }

  componentDidMount() {}

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_buildings = async () => {
    const { token } = this.props.user;

    this.setState({ loading: true });
    const result = await req_list_lrs_buildingSpace(token);
    this.setState({ loading: false });

    const buildings = result.data;
    this.setState({ buildings });
    //console.log(buildings);
  };

  api_list_rooms = async (buildingCode) => {
    const result = await req_list_lrs_spaceInformation(buildingCode);
    const rooms = result.total > 0 ? result.data : [];
    this.setState({ rooms });
    // console.log(rooms);
  };

  api_list_sessiontimes = async (roomCode) => {
    const result = await req_list_lrs_spaceSessionTime(roomCode);
    if (result.total) {
      const sessiontimes = result.total > 0 ? result.data : [];
      let sessionDates = [];
      this.groupBy(sessiontimes, "DateTag").forEach((key) => {
        sessionDates.push(key);
      });
      const onlyLendOneSession = sessiontimes[0].OnlyLendOneSession;

      this.setState({ sessiontimes, sessionDates, onlyLendOneSession });
      //console.log(sessionDates);
    }
  };

  api_add_item = (rows) => {
    const token = this.props.user.token;
    rows.forEach((row, idx, array) => {
      const result = req_add_lrs_lend(row, token);
      if (idx === array.length - 1) {
        const data = Promise.resolve(result);
        data
          .then((response) => {
            if (response.status === "success") {
              const { NeedSendMail } = this.state.selectedRoomInfo;
              // console.log('NeedSendMail', NeedSendMail)
              // 1.結果提示
              message.success("申請完成，待審查中....");
              // 2.寄發郵件
              if (NeedSendMail === "YES") {
                this.api_send_mail(row);
              }
              // 3.數據重置
              const { item } = this.state;
              item.ApplyNumber = getEvoucher();
              this.setState({
                item: item,
                items: [],
                sessiontimes: [],
                sessionDates: [],
                selectedSessiontimes: [],
                tabActive: "0",
                selectedRoom: "NONE",
                selectedRoomInfo: null,
              });
            } else {
            }
          })
          .catch((err) => console.log(err));
      }
    });
  };

  api_send_mail = (row) => {
    const token = this.props.user.token;
    const mailContent = {
      emailFrom: "<>",
      emailTo: row.ConfirmorAEmail,
      emailTitle:
        row.RoomCode +
        "-" +
        row.RoomName +
        "空間借用申請案(一審)-" +
        formateDate(new Date()),
      emailContent:
        "來自" +
        row.OperatorName +
        "對 " +
        row.RoomCode +
        "-" +
        row.RoomName +
        "借用申請，案號:" +
        row.ApplyNumber +
        "，請您至<a href='http://portal.tut.edu.tw/'>南應大入口-空間借用系統</a>處理",
    };

    req_send_mail(mailContent, token);
  };

  // 數據配置處理 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "學職號",
        width: 50,
        dataIndex: "BorrowerId",
        responsive: ["md"],
      },
      {
        title: "姓名",
        width: 50,
        dataIndex: "BorrowerName",
      },
      {
        title: "電子郵件",
        width: 150,
        dataIndex: "BorrowerEmail",
        responsive: ["md"],
      },
      {
        title: "行動電話",
        width: 100,
        dataIndex: "BorrowerPhone",
      },
      {
        title: "操作",
        width: 50,
        fixed: "right",
        render: (item) => {
          return (
            <span>
              <Button
                type="dashed"
                size="small"
                style={{ color: "Block" }}
                onClick={() => this.handleDeleteItem(item)}
              >
                <i className="fas fa-minus" style={{ marginRight: "4px" }}></i>{" "}
                刪除
              </Button>
            </span>
          );
        },
      },
    ];
  };

  groupBy = function (array, prop) {
    return Object.keys(
      array.reduce(function (groups, item) {
        const val = item[prop];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        return groups;
      }, {})
    );
  };

  setRooms = (value) => {
    this.api_list_rooms(value);
  };

  setSessiontimes = (value) => {
    this.api_list_sessiontimes(value);
  };

  getDayOfWeek = (date) => {
    const dayOfWeek = new Date(date).getDay();
    return isNaN(dayOfWeek)
      ? null
      : ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"][
          dayOfWeek
        ];
  };

  remove = (array, key, value) => {
    const index = array.findIndex((obj) => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  };

  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  validatePhone = (phone) => {
    const MobileReg = /^(09)[0-9]{8}$/;
    return phone.match(MobileReg) ? true : false;
  };

  // 操作互動處理 //////////////////////////////////////////////
  handleBuildingChange = (value) => {
    this.setState({
      items: [],
      sessiontimes: [],
      sessionDates: [],
      selectedSessiontimes: [],
      tabActive: "0",
      selectedRoom: "NONE",
      selectedRoomInfo: null,
    });
    this.setRooms(value);
    //console.log(value);
  };

  handleRoomChange = (value) => {
    const { rooms } = this.state;
    const selectedRoomInfo = rooms.filter(function (item) {
      return item.RoomCode === value;
    })[0];
    this.setState({
      items: [],
      sessiontimes: [],
      sessionDates: [],
      selectedSessiontimes: [],
      tabActive: "0",
      selectedRoom: value,
      selectedRoomInfo: selectedRoomInfo,
    });
    // console.log(selectedRoomInfo);
    this.setSessiontimes(value);
  };

  handleTabchange = (activeKey) => {
    this.setState({ tabActive: activeKey });
  };

  handlePeopleModalChange = (e) => {
    // const isCanNotSubmit = true;
    //console.log(e.target.value);
    if (e.target.value === "SINGLE") {
      this.setState({ groupPeople: [] });
    } else {
      // const { item } = this.state;
      // console.log(item);
    }
    this.setState({ peopleModal: e.target.value });
  };

  handleCheckboxChange = (e) => {
    //console.log(e.target.defaultValue);
    const selected = e.target.defaultValue;
    const { selectedSessiontimes } = this.state;
    const index = selectedSessiontimes.indexOf(selected);
    if (index > -1) {
      selectedSessiontimes.splice(index, 1); // 2nd parameter means remove one item only
    } else {
      selectedSessiontimes.push(selected);
    }
    this.setState({ selectedSessiontimes });
    //console.log(selectedSessiontimes);
  };

  handleRadioChange = (e) => {
    //console.log(e.target.value);
    const selected = e.target.value;
    //console.log(selected.substr(0, 10));
    const { selectedSessiontimes } = this.state;
    const tempArray = [];
    selectedSessiontimes.forEach((element) => {
      tempArray.push(element.substr(0, 10));
    });
    const index = tempArray.indexOf(selected.substr(0, 10));
    if (index > -1) {
      selectedSessiontimes.splice(index, 1); // 2nd parameter means remove one item only
      selectedSessiontimes.push(selected);
    } else {
      selectedSessiontimes.push(selected);
    }
    this.setState({ selectedSessiontimes });

    //console.log(selectedSessiontimes);
  };

  handleReadEcxel = (file) => {
    // console.log(file);
    if (file !== undefined) {
      const promise = new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);

        fileReader.onload = (e) => {
          const bufferArray = e.target.result;

          const wb = XLSX.read(bufferArray, { type: "buffer" });
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws);

          resolve(data);
        };

        fileReader.onerror = (error) => {
          reject(error);
        };
      });

      promise.then((data) => {
        //console.log(data);
        if (data !== null && data.length > 0) {
          const groupPeople = [];
          data.forEach((d) => {
            const item = {
              BorrowerId: d.學職號,
              BorrowerName: d.姓名,
              BorrowerEmail: d.電子郵件,
              BorrowerPhone: d.行動電話,
            };
            groupPeople.push(item);
          });
          // console.log(groupPeople);
          this.setState({ groupPeople });
        }
      });
    }
  };

  handleDeleteItem = (item) => {
    const { BorrowerId } = item;
    const { groupPeople } = this.state;
    const items = this.remove(groupPeople, "BorrowerId", BorrowerId);
    this.setState({ groupPeople: items });
  };

  handleSetValue = (field, value) => {
    const { item } = this.state;
    if (field === "BorrowerEmail") {
      item.BorrowerEmail = value;
    } else if (field === "BorrowerPhone") {
      item.BorrowerPhone = value;
    } else if (field === "BorrowDescription") {
      item.BorrowDescription = value;
    }
    this.setState({ item });
  };

  handleSumbit = () => {
    const {
      sessiontimes,
      selectedSessiontimes,
      peopleModal,
      groupPeople,
      selectedRoomInfo,
      item,
      items,
    } = this.state;

    if (peopleModal === "SINGLE") {
      if (item.BorrowerPhone !== "" && item.OperatorEmail !== "") {
        if (
          this.validateEmail(item.OperatorEmail) &&
          this.validatePhone(item.BorrowerPhone)
        ) {
          item.BorrowerEmail = item.OperatorEmail;
          item.BuildingCode = selectedRoomInfo.BuildingCode;
          item.BuildingName = selectedRoomInfo.BuildingName;
          item.RoomCode = selectedRoomInfo.RoomCode;
          item.RoomName = selectedRoomInfo.RoomTwName;
          item.MustConfirmLevel = selectedRoomInfo.MustConfirmLevel;
          item.ConfirmorACode = selectedRoomInfo.ConfirmorACode;
          item.ConfirmorAName = selectedRoomInfo.ConfirmorATwName;
          item.ConfirmorAEmail = selectedRoomInfo.ConfirmorAEmail;
          item.ConfirmorBCode = selectedRoomInfo.ConfirmorBCode;
          item.ConfirmorBName = selectedRoomInfo.ConfirmorBTwName;
          item.ConfirmorBEmail = selectedRoomInfo.ConfirmorBEmail;
          item.ConfirmorCCode = selectedRoomInfo.ConfirmorCCode;
          item.ConfirmorCName = selectedRoomInfo.ConfirmorCTwName;
          item.ConfirmorCEmail = selectedRoomInfo.ConfirmorCEmail;

          selectedSessiontimes.forEach((time) => {
            const DateTag = time.substr(0, 10);
            const WeekCode = this.getDayOfWeek(DateTag).substr(2, 1);
            const TimeStart = time.substr(11, 4);
            // console.log('TimeStart',TimeStart)
            const TimeEnd = time.substr(15, 4);
            // console.log('TimeEnd',TimeEnd)
            let TimeName = sessiontimes.filter(function (currentElement) {
              return (
                currentElement.DateTag === DateTag &&
                currentElement.TimeStart === TimeStart
              );
            })[0].TimeName;
            const data = {
              ApplyStatus: item.ApplyStatus,
              ApplyNumber: item.ApplyNumber,
              OperatorId: item.OperatorId,
              OperatorName: item.OperatorName,
              OperatorEmail: item.OperatorEmail,
              BorrowerId: item.BorrowerId,
              BorrowerName: item.BorrowerName,
              BorrowerEmail: item.BorrowerEmail,
              BorrowerPhone: item.BorrowerPhone,
              BorrowDescription: item.BorrowDescription,
              MustConfirmLevel: item.MustConfirmLevel,
              ConfirmorACode: item.ConfirmorACode,
              ConfirmorAName: item.ConfirmorAName,
              ConfirmorAEmail: item.ConfirmorAEmail,
              ConfirmorBCode: item.ConfirmorBCode,
              ConfirmorBName: item.ConfirmorBName,
              ConfirmorBEmail: item.ConfirmorBEmail,
              ConfirmorCCode: item.ConfirmorCCode,
              ConfirmorCName: item.ConfirmorCName,
              ConfirmorCEmail: item.ConfirmorCEmail,
              BuildingCode: item.BuildingCode,
              BuildingName: item.BuildingName,
              RoomCode: item.RoomCode,
              RoomName: item.RoomName,
              SiteCode: "NONE",
              DateTag: DateTag,
              WeekCode: WeekCode,
              TimeStart: TimeStart,
              TimeEnd: TimeEnd,
              TimeName: TimeName,
            };
            //console.log('row',data)
            items.push(data);
          });
          //console.log('items', items)
          this.setState({ items }, () => {
            this.sendData(items);
          });
        } else {
          message.info("行動電話或電子郵件格式不正確");
        }
      } else {
        message.info("行動電話及電子郵件不能空值");
      }
    } else {
      if (groupPeople !== []) {
        item.BuildingCode = selectedRoomInfo.BuildingCode;
        item.BuildingName = selectedRoomInfo.BuildingName;

        item.RoomCode = selectedRoomInfo.RoomCode;
        item.RoomName = selectedRoomInfo.RoomTwName;

        item.MustConfirmLevel = selectedRoomInfo.MustConfirmLevel;
        item.ConfirmorACode = selectedRoomInfo.ConfirmorACode;
        item.ConfirmorAName = selectedRoomInfo.ConfirmorATwName;
        item.ConfirmorAEmail = selectedRoomInfo.ConfirmorAEmail;

        item.ConfirmorBCode = selectedRoomInfo.ConfirmorBCode;
        item.ConfirmorBName = selectedRoomInfo.ConfirmorBTwName;
        item.ConfirmorBEmail = selectedRoomInfo.ConfirmorBEmail;

        item.ConfirmorCCode = selectedRoomInfo.ConfirmorCCode;
        item.ConfirmorCName = selectedRoomInfo.ConfirmorCTwName;
        item.ConfirmorCEmail = selectedRoomInfo.ConfirmorCEmail;

        selectedSessiontimes.forEach((time) => {
          const DateTag = time.substr(0, 10);
          const WeekCode = this.getDayOfWeek(DateTag).substr(2, 1);
          const TimeStart = time.substr(11, 4);
          const TimeEnd = time.substr(15, 4);
          let TimeName = sessiontimes.filter(function (currentElement) {
            return (
              currentElement.DateTag === DateTag &&
              currentElement.TimeStart === TimeStart
            );
          })[0].TimeName;
          item.TimeName = TimeName;
          item.DateTag = DateTag;
          item.WeekCode = WeekCode;
          item.TimeStart = TimeStart;
          item.TimeEnd = TimeEnd;

          groupPeople.forEach((member) => {
            item.BorrowerId = member.BorrowerId;
            item.BorrowerName = member.BorrowerName;
            item.BorrowerEmail = member.BorrowerEmail;
            item.BorrowerPhone = member.BorrowerPhone;

            const data = {
              ApplyStatus: item.ApplyStatus,
              ApplyNumber: item.ApplyNumber,
              OperatorId: item.OperatorId,
              OperatorName: item.OperatorName,
              OperatorEmail: item.OperatorEmail,
              BorrowerId: item.BorrowerId,
              BorrowerName: item.BorrowerName,
              BorrowerEmail: item.BorrowerEmail,
              BorrowerPhone: item.BorrowerPhone,
              BorrowDescription: item.BorrowDescription,
              MustConfirmLevel: item.MustConfirmLevel,
              ConfirmorACode: item.ConfirmorACode,
              ConfirmorAName: item.ConfirmorAName,
              ConfirmorAEmail: item.ConfirmorAEmail,
              ConfirmorBCode: item.ConfirmorBCode,
              ConfirmorBName: item.ConfirmorBName,
              ConfirmorBEmail: item.ConfirmorBEmail,
              ConfirmorCCode: item.ConfirmorCCode,
              ConfirmorCName: item.ConfirmorCName,
              ConfirmorCEmail: item.ConfirmorCEmail,
              BuildingCode: item.BuildingCode,
              BuildingName: item.BuildingName,
              RoomCode: item.RoomCode,
              RoomName: item.RoomName,
              SiteCode: "NONE",
              DateTag: DateTag,
              WeekCode: WeekCode,
              TimeStart: TimeStart,
              TimeEnd: TimeEnd,
              TimeName: TimeName,
            };
            items.push(data);
          });
        });
        this.setState({ items }, () => {
          this.sendData(items);
        });
      } else {
        message.info("人員清單不能空");
      }
    }
  };

  sendData = (items) => {
    items.length > 0 ? this.api_add_item(items) : message.warn("無法送出申請");
  };

  handleDownload = () => {
    const downloadUrl = API_BASE + "/Templates/List.xlsx";

    // download file link
    let a = document.createElement("a");
    a.href = downloadUrl;
    a.target = "_blank";
    a.download = "參加人員清單";
    a.click();
  };

  handleSwitchChange = (checked) => {
    checked
      ? this.setState({ showSessionTimeStyle: "TIME" })
      : this.setState({ showSessionTimeStyle: "SESSION" });
  };

  handClearChoiced = () => {
    const selectedRoom = "NONE";
    this.setState({ selectedRoom: selectedRoom, selectedSessiontimes: [] });
    this.handleRoomChange(selectedRoom);
  };

  //////////////////////////////////////////////////////////
  render() {
    const {
      buildings,
      rooms,
      isSelected,
      selectedRoom,
      selectedRoomInfo,
      sessionDates,
      sessiontimes,
      selectedSessiontimes,
      tabActive,
      peopleModalChoice,
      peopleModal,
      onlyLendOneSession,
      groupPeople,
      item,
      showSessionTimeStyle,
    } = this.state;

    const listRooms =
      rooms.length > 0 ? (
        <>
          {rooms.map((item) => (
            <Option
              key={item.RoomCode}
              value={item.RoomCode}
              disabled={item.RoomStatus === "CLOSE"}
            >
              {item.RoomCode} {item.RoomTwName}
            </Option>
          ))}
        </>
      ) : (
        ""
      );

    const listSessions =
      sessionDates.length > 0 ? (
        <>
          {sessionDates.sort().map((item) => (
            <div
              className="col-sm "
              key={item}
              style={{ margin: "0px", padding: "0px" }}
            >
              <Card
                style={{
                  fontSize: "1.1em",
                  textAlign: "center",
                }}
                key={this.getDayOfWeek(item)}
              >
                <div style={{ fontWeight: "bold" }}>
                  <div>{item}</div>
                  <div>{this.getDayOfWeek(item)}</div>
                </div>
                {onlyLendOneSession === "YES" ? (
                  <div align="left">
                    <Radio.Group onChange={this.handleRadioChange}>
                      {sessiontimes
                        .filter((sessiontime) => sessiontime.DateTag === item)
                        .map((data) => (
                          <>
                            {data.DefaultStatus === "CLOSE" ? (
                              <Radio
                                disabled
                                key={
                                  data.DateTag +
                                  "-" +
                                  data.TimeStart +
                                  data.TimeEnd
                                }
                                value={
                                  data.DateTag +
                                  "-" +
                                  data.TimeStart +
                                  data.TimeEnd
                                }
                              >
                                <Popover
                                  placement="topLeft"
                                  content={"預設不開放"}
                                >
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      textDecoration: "line-through",
                                    }}
                                  >
                                    {showSessionTimeStyle === "TIME" ? (
                                      <>
                                        {data.TimeStart}-{data.TimeEnd}
                                      </>
                                    ) : (
                                      <>{data.TimeName}</>
                                    )}
                                  </span>
                                </Popover>
                              </Radio>
                            ) : (
                              <Radio
                                key={
                                  data.DateTag +
                                  "-" +
                                  data.TimeStart +
                                  data.TimeEnd
                                }
                                disabled={
                                  data.HadCourse === "Y" ||
                                  data.HadSpecialDay === "Y" ||
                                  (data.OnlyLendOnePeople === "YES" &&
                                    data.BorrowTotal > 0)
                                }
                                value={
                                  data.DateTag +
                                  "-" +
                                  data.TimeStart +
                                  data.TimeEnd
                                }
                              >
                                <Popover
                                  placement="topLeft"
                                  content={
                                    data.HadCourse === "Y" ||
                                    data.HadSpecialDay === "Y" ||
                                    (data.OnlyLendOnePeople === "YES" &&
                                      data.BorrowTotal > 0)
                                      ? "課程占用(灰)、暫停開放(灰)或已借出(橘)"
                                      : "開放申請"
                                  }
                                >
                                  <span
                                    style={{
                                      color:
                                        data.HadCourse === "Y" ||
                                        data.HadSpecialDay === "Y" ||
                                        (data.OnlyLendOnePeople === "YES" &&
                                          data.BorrowTotal > 0)
                                          ? ""
                                          : "green",

                                      fontWeight: "bold",
                                    }}
                                  >
                                    {data.OnlyLendOnePeople === "YES" &&
                                    data.BorrowTotal > 0 ? (
                                      <span style={{ color: "Orange " }}>
                                        {" "}
                                        {showSessionTimeStyle === "TIME" ? (
                                          <>
                                            {data.TimeStart}-{data.TimeEnd}
                                          </>
                                        ) : (
                                          <>{data.TimeName}</>
                                        )}
                                      </span>
                                    ) : (
                                      <>
                                        {" "}
                                        {showSessionTimeStyle === "TIME" ? (
                                          <>
                                            {data.TimeStart}-{data.TimeEnd}
                                          </>
                                        ) : (
                                          <>{data.TimeName}</>
                                        )}
                                      </>
                                    )}
                                  </span>
                                </Popover>
                              </Radio>
                            )}
                          </>
                        ))}
                    </Radio.Group>
                  </div>
                ) : (
                  <div align="left">
                    {sessiontimes
                      .filter((sessiontime) => sessiontime.DateTag === item)
                      .map((data) => (
                        <>
                          {data.DefaultStatus === "CLOSE" ? (
                            <Checkbox
                              disabled
                              key={
                                data.DateTag +
                                "-" +
                                data.TimeStart +
                                data.TimeEnd
                              }
                            >
                              <Popover
                                placement="topLeft"
                                content={"預設不開放"}
                              >
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    textDecoration: "line-through",
                                  }}
                                >
                                  {showSessionTimeStyle === "TIME" ? (
                                    <>
                                      {data.TimeStart}-{data.TimeEnd}
                                    </>
                                  ) : (
                                    <>{data.TimeName}</>
                                  )}
                                </span>
                              </Popover>
                            </Checkbox>
                          ) : (
                            <Checkbox
                              key={
                                data.DateTag +
                                "-" +
                                data.TimeStart +
                                data.TimeEnd
                              }
                              disabled={
                                data.HadCourse === "Y" ||
                                data.HadSpecialDay === "Y" ||
                                (data.OnlyLendOnePeople === "YES" &&
                                  data.BorrowTotal > 0)
                              }
                              onChange={this.handleCheckboxChange}
                              defaultValue={
                                data.DateTag +
                                "-" +
                                data.TimeStart +
                                data.TimeEnd
                              }
                            >
                              <Popover
                                placement="topLeft"
                                content={
                                  data.HadCourse === "Y" ||
                                  data.HadSpecialDay === "Y" ||
                                  (data.OnlyLendOnePeople === "YES" &&
                                    data.BorrowTotal > 0)
                                    ? "課程占用(灰)、暫停開放(灰)或已借出(橘)"
                                    : "開放申請"
                                }
                              >
                                <span
                                  style={{
                                    color:
                                      data.HadCourse === "Y" ||
                                      data.HadSpecialDay === "Y"
                                        ? ""
                                        : "green",

                                    fontWeight: "bold",
                                  }}
                                >
                                  {data.OnlyLendOnePeople === "YES" &&
                                  data.BorrowTotal > 0 ? (
                                    <span style={{ color: "Orange" }}>
                                      {" "}
                                      {showSessionTimeStyle === "TIME" ? (
                                        <>
                                          {data.TimeStart}-{data.TimeEnd}
                                        </>
                                      ) : (
                                        <>{data.TimeName}</>
                                      )}
                                    </span>
                                  ) : (
                                    <>
                                      {" "}
                                      {showSessionTimeStyle === "TIME" ? (
                                        <>
                                          {data.TimeStart}-{data.TimeEnd}
                                        </>
                                      ) : (
                                        <>{data.TimeName}</>
                                      )}
                                    </>
                                  )}
                                </span>
                              </Popover>
                            </Checkbox>
                          )}
                        </>
                      ))}
                  </div>
                )}
              </Card>
            </div>
          ))}
        </>
      ) : (
        ""
      );

    return (
      <>
        <Select
          style={{ width: 180 }}
          onChange={this.handleBuildingChange}
          defaultValue={isSelected}
        >
          <Option key={"NONE"} value={"NONE"}>
            請選擇
          </Option>
          {buildings.map((building) => (
            <Option key={building.BuildingCode} value={building.BuildingCode}>
              {building.BuildingCode}-{building.BuildingName}
            </Option>
          ))}
        </Select>
        <Select
          style={{ width: 220 }}
          onChange={this.handleRoomChange}
          defaultValue={selectedRoom}
          value={selectedRoom}
          allowClear
        >
          <Option key={"NONE"} value={"NONE"}>
            請選擇
          </Option>
          {listRooms}
        </Select>
        <div className="container-fluid">
          <Tabs defaultActiveKey="0" size="small" activeKey={tabActive}>
            <TabPane tab="空間說明" key="0" disabled={tabActive !== "0"}>
              <button
                type="button"
                className="btn btn-success"
                style={{ marginRight: "2px" }}
                onClick={() => this.handleTabchange("1")}
                disabled={selectedRoom === "NONE"}
              >
                <i className="fas fa-door-open"></i> 申請借用
              </button>
              {selectedRoomInfo != null ? (
                <div style={{ fontSize: "1.3em" }}>
                  {" "}
                  <div>
                    <i className="fas fa-building"></i> 管理單位：
                    {selectedRoomInfo.ServiceUnitName}
                  </div>
                  <div>
                    <i className="fas fa-user-lock"></i> 管理者：
                    {selectedRoomInfo.ConfirmorATwName}
                  </div>
                  <div>
                    <i className="fas fa-phone-square"></i> 聯絡電話：
                    {selectedRoomInfo.ServiceUnitPhone}
                  </div>
                  <div>
                    {selectedRoomInfo.RecordDescription !== null ? (
                      <>
                        <i className="fas fa-book"></i> 借用說明：
                        <br></br>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: selectedRoomInfo.RecordDescription,
                          }}
                        />
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                  <div>
                    {selectedRoomInfo.NeedFee === "NO" ? (
                      ""
                    ) : (
                      <Tag color="red">
                        <i className="fas fa-dollar-sign"></i> 具收費標準規範
                      </Tag>
                    )}
                    {selectedRoomInfo.NeedSignInOut === "NO" ? (
                      ""
                    ) : (
                      <Tag color="blue">
                        <i className="fas fa-file-signature"></i>{" "}
                        需登載進出入紀錄
                      </Tag>
                    )}
                    {selectedRoomInfo.NeedCheckThings === "NO" ? (
                      ""
                    ) : (
                      <Tag color="green">
                        <i className="fas fa-check-double"></i>{" "}
                        用完後須通知管理者點交
                      </Tag>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
            </TabPane>
            <TabPane tab="選擇時段" key="1" disabled={tabActive !== "1"}>
              <></>
              <button
                type="button"
                className="btn btn-default btn-sm"
                style={{ marginRight: "2px" }}
                onClick={() => this.handleTabchange("0")}
              >
                <i className="fas fa-angle-left"></i> 上一步驟
              </button>
              <button
                type="button"
                className="btn btn-success btn-sm"
                style={{ marginRight: "2px" }}
                onClick={() => this.handleTabchange("2")}
                disabled={selectedSessiontimes.length === 0}
              >
                下一步驟 <i className="fas fa-angle-right"></i>
              </button>
              <button
                className="btn btn-primary btn-sm"
                onClick={this.handClearChoiced}
              >
                <i className="fas fa-recycle"></i> 重新選擇
              </button>
              <Switch
                checkedChildren="顯示時段"
                unCheckedChildren="顯示節次"
                defaultChecked={showSessionTimeStyle === "TIME" ? true : false}
                onChange={this.handleSwitchChange}
              />
              <div className="row" style={{ margin: "0px", padding: "0px" }}>
                {listSessions}
              </div>
            </TabPane>
            <TabPane tab="進出人員" key="2" disabled={tabActive !== "2"}>
              <button
                type="button"
                className="btn btn-default btn-sm"
                style={{ marginRight: "2px" }}
                onClick={() => this.handleTabchange("1")}
              >
                <i className="fas fa-angle-left"></i> 上一步驟
              </button>
              <button
                type="button"
                className="btn btn-success btn-sm"
                style={{ marginRight: "2px" }}
                onClick={() => this.handleSumbit()}
              >
                <i className="fas fa-save"></i> 送出申請
              </button>
              <p></p>

              {selectedRoomInfo != null ? (
                <>
                  {selectedRoomInfo.OnlyLendOnePeople === "YES" ? (
                    ""
                  ) : (
                    <Radio.Group
                      options={peopleModalChoice}
                      defaultValue={peopleModal}
                      onChange={this.handlePeopleModalChange}
                      buttonStyle="solid"
                      optionType="button"
                    />
                  )}
                </>
              ) : (
                ""
              )}
              <div>
                {peopleModal === "SINGLE" ? (
                  <>
                    <p></p>
                    <Input
                      placeholder="請輸入您的學/職號"
                      value={item.BorrowerId}
                      disabled={true}
                      prefix={<i className="fas fa-address-card"></i>}
                      suffix={
                        <Tooltip title="若非本校師生，請輸入身份證字號">
                          <InfoCircleOutlined
                            style={{ color: "rgba(0,0,0,.45)" }}
                          />
                        </Tooltip>
                      }
                    />
                    <Input
                      placeholder="請輸入您的姓名"
                      value={item.BorrowerName}
                      disabled={true}
                      prefix={<i className="fas fa-user"></i>}
                      suffix={
                        <Tooltip title="若非本國籍人士，請輸入護照英文姓名">
                          <InfoCircleOutlined
                            style={{ color: "rgba(0,0,0,.45)" }}
                          />
                        </Tooltip>
                      }
                    />
                    <Input
                      placeholder="請輸入您的電子郵件"
                      prefix={<i className="fas fa-envelope"></i>}
                      defaultValue={item.OperatorEmail}
                      onChange={(e) =>
                        this.handleSetValue("OperatorEmail", e.target.value)
                      }
                      suffix={
                        <Tooltip title="">
                          <InfoCircleOutlined
                            style={{ color: "rgba(0,0,0,.45)" }}
                          />
                        </Tooltip>
                      }
                    />
                    <Input
                      placeholder="請輸入您的行動電話(格式：0900111222)"
                      prefix={<i className="fas fa-mobile-alt"></i>}
                      defaultValue={item.BorrowerPhone}
                      onChange={(e) =>
                        this.handleSetValue("BorrowerPhone", e.target.value)
                      }
                      suffix={
                        <Tooltip title="">
                          <InfoCircleOutlined
                            style={{ color: "rgba(0,0,0,.45)" }}
                          />
                        </Tooltip>
                      }
                    />
                    <Input
                      placeholder="用途說明"
                      prefix={<i className="fas fa-comment-alt"></i>}
                      defaultValue={item.BorrowDescription}
                      onChange={(e) =>
                        this.handleSetValue("BorrowDescription", e.target.value)
                      }
                      suffix={
                        <Tooltip title="">
                          <InfoCircleOutlined
                            style={{ color: "rgba(0,0,0,.45)" }}
                          />
                        </Tooltip>
                      }
                    />
                  </>
                ) : (
                  <>
                    <p></p>
                    <div style={{ marginBottom: "2px" }}>
                      <Button
                        type="primary"
                        shape="round"
                        onClick={() => this.handleDownload()}
                        danger
                      >
                        <i className="fas fa-cloud-download-alt"></i>
                        <span>下載範例檔</span>
                      </Button>
                    </div>

                    <Divider orientation="left" plain>
                      <i className="fas fa-user-friends"></i> 人員清單
                    </Divider>

                    <label className="btn btn-primary">
                      <i className="fas fa-cloud-upload-alt"></i> 上傳檔案
                      <input
                        type="file"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          this.handleReadEcxel(file);
                        }}
                        accept=".xlsx"
                        hidden
                      ></input>
                    </label>
                    <br></br>
                    <span style={{ color: "red" }}>
                      *申請者應將自己一併填入EXCEL檔之中，若只是代為申請未進入則不用
                    </span>
                    <Table
                      dataSource={groupPeople}
                      columns={this.columns}
                      rowKey="BorrowerId"
                      scroll={{ y: 600 }}
                      pagination={false}
                    />
                    <Input
                      placeholder="用途說明"
                      prefix={<i className="fas fa-comment-alt"></i>}
                      defaultValue={item.BorrowDescription}
                      onChange={(e) =>
                        this.handleSetValue("BorrowDescription", e.target.value)
                      }
                      suffix={
                        <Tooltip title="">
                          <InfoCircleOutlined
                            style={{ color: "rgba(0,0,0,.45)" }}
                          />
                        </Tooltip>
                      }
                    />
                  </>
                )}
              </div>
            </TabPane>
          </Tabs>
        </div>
      </>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(UserBorrowSpace);
